import { useNavigate } from "react-router-dom";
import { useRoster } from "../../hooks/use-roster";
import { RosterCard } from "./roster-card";

export const Roster = ({ teamId, years }) => {
  const navigate = useNavigate();
  const { status, selectedYear, setSelectedYear, availableYears, roster } = useRoster({ teamId, years });

  if (status === "loading") {
    return (
      <div className="flex items-center justify-center py-16">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-blue-200 border-t-blue-600" />
      </div>
    );
  }

  if (status === "error") {
    return <div className="py-12 text-center text-sm text-gray-500">Couldn&apos;t load roster.</div>;
  }

  return (
    <div className="p-2 pl-6">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        {availableYears.length > 0 ? (
          <div className="flex items-center gap-2">
            <div className="text-xs font-medium text-gray-500">Year</div>
            <select
              value={selectedYear ?? ""}
              onChange={(e) => setSelectedYear(Number(e.target.value))}
              className="rounded-lg border border-gray-200 bg-white px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              {availableYears.map((yr) => (
                <option key={yr} value={yr}>
                  {yr}
                </option>
              ))}
            </select>
          </div>
        ) : null}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {roster.map((player) => (
          <RosterCard
            key={player.player_id}
            player={player}
            onClick={() => navigate(`/player/${player.player_id}`)}
          />
        ))}
      </div>
      {roster.length === 0 && (
        <div className="text-center py-12 text-gray-500">No roster data available</div>
      )}
    </div>
  );
};
